import $ from 'jquery';
import { scrollToElm } from 'Util/core';
import { modal } from 'App/modal/modal';

import { Validate } from 'App/form/validate';
import { subscribe, publish } from 'Util/pubsub';

var $summary;
var tncConfirmed = false;
var hasFees = false;

function Person(id, title, fn, ln) {
	this.PersonId = parseInt(id, 10);
	this.Title = title;
	this.FirstName = fn;
	this.LastName = ln;
}

var module = {
	init: function () {

		$summary = $('.js-summary');

		// Check if payment button exists (server-side renders this when TotalFeeValue > 0)
		hasFees = $('.js-payment-button').length > 0;
		console.log('Has fees (payment scenario):', hasFees);

		modal.init();
		Validate.init();
		module._initSubscriptions();
		module._initEvents();
	},

	_initSubscriptions: function () {
		subscribe('/form/' + $summary.attr('id') + '/valid', module._submitSummary);
	},

	_initEvents: function () {
		// Handle submit button click
		$summary.on('click', '.js-validate-submit', function(e) {
			// If T&C not confirmed yet, show modal instead of submitting
			if (!tncConfirmed) {
				e.preventDefault();
				e.stopImmediatePropagation();
				publish('/modal/open', 't-and-c-modal');
				return false;
			}
			// If T&C confirmed, allow normal validation/submission flow
		});

		// Close T&C modal when cancel button is clicked
		$(document).on('click', '.js-tnc-cancel-btn', function (e) {
			publish('/modal/close');
		});

		// Reset checkbox state and bind scroll event when modal opens
		subscribe('/modal/opened', function($modal) {
			if ($modal && $modal.attr('id') === 't-and-c-modal') {
				// Ensure checkbox and button are disabled when modal opens
				var $confirmBtn = $('.js-tnc-confirm-btn');
				var $content = $('.c-modal--t-and-c__content');

				$confirmBtn.prop('disabled', true);

				// Reset scroll position to top
				$content.scrollTop(0);

				// Bind scroll event directly to the content element
				$content.off('scroll', module._handleTncScroll);
				$content.on('scroll', module._handleTncScroll);

				// Only check if content is short enough that no scrolling is needed
				if ($content.length && $content[0].scrollHeight <= $content[0].clientHeight) {
					// Content doesn't overflow, enable checkbox immediately
					$confirmBtn.prop('disabled', false);
				}
			}
		});

		// Handle T&C confirm button/checkbox click
		$(document).on('click', '.js-tnc-confirm-btn', function(e) {
			// Check if it's a checkbox (for the non-modal scenario)
			if ($(this).is(':checkbox')) {
				if ($(this).is(':checked')) {
					tncConfirmed = true;
					console.log('T&C checkbox checked, tncConfirmed:', tncConfirmed);
					if (hasFees) {
						$('.js-payment-button').removeClass('u-hidden');
						$('.js-continue-button').addClass('u-hidden');
					}
				} else {
					tncConfirmed = false;
					console.log('T&C checkbox unchecked, tncConfirmed:', tncConfirmed);
					if (hasFees) {
						$('.js-payment-button').addClass('u-hidden');
						$('.js-continue-button').removeClass('u-hidden');
					}
				}
			} else {
				// Button click (modal scenario)
				//e.preventDefault();
				tncConfirmed = true;
				console.log('T&C confirmed, tncConfirmed:', tncConfirmed);

				publish('/modal/close');

				if (hasFees) {
					// Remove hidden class from payment button
					$('.js-payment-button').removeClass('u-hidden');
					$('.js-continue-button').addClass('u-hidden');
				}
			}

		});
	},

	_handleTncScroll: function() {
		module._checkTncScrollPosition();
	},

	_checkTncScrollPosition: function() {
		var $content = $('.c-modal--t-and-c__content');

		if ($content.length) {
			var scrollTop = $content.scrollTop();
			var scrollHeight = $content[0].scrollHeight;
			var clientHeight = $content[0].clientHeight;

			// Check if scrolled to bottom (with 5px threshold for better UX)
			if (scrollTop + clientHeight >= scrollHeight - 5) {
				var $confirmBtn = $('.js-tnc-confirm-btn');
				$confirmBtn.prop('disabled', false);
			}
		}
	},

	_submitSummary: function () {
		console.log('_submitSummary called, tncConfirmed:', tncConfirmed);
		// Don't submit if T&C hasn't been confirmed
		if (!tncConfirmed) {
			console.log('Submission blocked - T&C not confirmed');
			return false;
		}

		var data = $summary.serialize();
		var dataArray = data.split('&');
		var summaryData = {};

		module._showLoadingButton($summary);

		for (var i = 0; i < dataArray.length; i++) {
			var field = dataArray[i].split('=');
			summaryData[field[0]] = decodeURIComponent(field[1]);

			if (summaryData[field[0]].indexOf('+')) {
				summaryData[field[0]] = summaryData[field[0]].replace(/\+/g, ' ');
			}
		}

		// Customer (Card Holder)
		summaryData.Customer = new Person(
			0,
			summaryData.CustomerTitle,
			summaryData.CustomerFirstName,
			summaryData.CustomerLastName
		);

		summaryData.Customer.Address = summaryData.Address;
		summaryData.Customer.Suburb = summaryData.Suburb;
		summaryData.Customer.City = summaryData.City;
		summaryData.Customer.Postcode = summaryData.Postcode;
		summaryData.Customer.Phone = summaryData.Phone;
		summaryData.Customer.Email = summaryData.Email;

		// Spouse
		summaryData.Spouse = new Person(
			0,
			summaryData.SpouseTitle,
			summaryData.SpouseFirstName,
			summaryData.SpouseLastName
		);

		// Family Members
		var familyMembers = [];
		var $dependants = $('.js-dependant');

		for (var k = 0; k < $dependants.length; k++) {
			var num = k + 1;
			var member = new Person(
				summaryData['ChildPersonId' + num],
				summaryData['ChildTitle' + num],
				summaryData['ChildFirstName' + num],
				summaryData['ChildLastName' + num]
			);
			familyMembers.push(member);
		}

		summaryData.FamilyMembers = familyMembers;

		$.ajax({
			type: 'POST',
			url: $summary.attr('action'),
			data: JSON.stringify(summaryData),
			contentType: 'application/json',
			success: function (response) {
				if (response.NextStepUrl) {
					var url = response.NextStepUrl;
					window.location.replace(url);
				} else if (Array.isArray(response)) {
					module._showErrors(response);
				} else {
					console.error(response);
				}
			},
			error: function (error) {
				window.location.replace('error');
			}
		});
	},

	_showErrors: function(errList) {
		console.error(errList);

		$summary.find('.js-validate-field.has-error').removeClass('has-error');
		$summary.find('.js-validate-field-validation').empty();

		for (var i = 0, l = errList.length; i < l; i++) {
			var err = errList[i];
			var $input = $summary.find('input[name="' + err.Name + '"]');
			if ($input) {
				var $field = $input.closest('.js-validate-field');
				var $message = $field.find('.js-validate-field-validation');

				$field.addClass('has-error');
				$message.text(err.Message);
			}
		}

		// reset submission button
		var $submit = $summary.find('.js-loader-btn');
		$submit.html($submit.data('initial'));
		$submit.attr('disabled', false);

		scrollToElm($summary.find('.js-validate-field.has-error').first(), 100);
	},

	// Disabled submit button
	// Add loading text to button - this will be animated by CSS
	_showLoadingButton: function ($form) {
		var $submit = $form.find('.js-loader-btn');
		$submit.data('initial', $submit.html());

		if ($submit.length) {
			$submit.html('<span>L</span><span>O</span><span>A</span><span>D</span><span>I</span><span>N</span><span>G</span>');
			$submit.attr('disabled', true);
		}
	}
};

var Summary = {
	init: module.init
};

export { Summary };